import Marquee from "react-fast-marquee";
import { PARTNERS } from "../lib/brand";

function LogoCard({ p }) {
  return (
    <div
      data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
      className="mx-3 flex h-24 w-44 items-center justify-center rounded-sm border border-border bg-cream-100 px-6 transition-colors duration-500 hover:border-gold"
      title={p.name}
    >
      <img
        src={p.src}
        alt={p.name}
        loading="lazy"
        className="max-h-14 w-auto max-w-[120px] object-contain transition-transform duration-500 hover:scale-105"
      />
    </div>
  );
}

export default function PartnerMarquee() {
  return (
    <div data-testid="partner-marquee" className="select-none">
      <Marquee speed={38} gradient gradientColor="#FBF8F0" gradientWidth={120} pauseOnHover>
        {PARTNERS.map((p) => (
          <LogoCard key={p.name} p={p} />
        ))}
      </Marquee>
    </div>
  );
}
